<script setup lang="ts">
import { usePlayerCreditStore } from '@/stores/playerCreditStore.ts'
import ColoredNumber from '@/components/Elements/Generic/ColoredNumber.vue'

const props = defineProps({
  header: {
    type: String,
    required: true
  },
  subheader: {
    type: String,
    required: false,
    default: ''
  },
  amount: {
    type: Number,
    required: true
  },
  total: {
    type: Boolean,
    required: false,
    default: false
  },
  type: {
    type: String,
    required: false,
    default: ''
  }
})

const playerCreditStore = usePlayerCreditStore()

const openDetails = () => {
  if (props.type != '') {
    playerCreditStore.balanceSheetDetails = props.type
  }
}
</script>

<template>
  <div
    :class="{
      'flex justify-between py-1 ': true,
      'cursor-pointer py-1 hover:bg-metal-800 hover:rounded': !total
    }"
    @click="openDetails"
  >
    <div class="ps-1 flex">
      <div class="text-metal-400">
        {{ header }} <span v-if="subheader" class="text-xs text-metal-600">{{ subheader }}</span>
      </div>
    </div>
    <div class="pe-2">
      <ColoredNumber :amount="amount" />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
